import { useContext, useEffect, useState } from 'react';

import Button from '../../reusable/button/button.component';
import { ToastContext } from '../../../contexts/toast.context';

import Client from '../../../tools/client';
import { setMobileView } from '../../../tools/mobileView';

import {
  Input,
  MainContainer,
  RowContainer,
  Subtitle,
  Textarea,
  Title
} from '../../../styles/component.styles';

const client = new Client();

const UpdateCompany = ({ company, getCompany, setShowUpdate }) => {
  const [name, setName] = useState(company.name || '');
  const [bio, setBio] = useState(company.bio || '');
  const [url, setUrl] = useState(company.url || '');
  const [discord, setDiscord] = useState('');
  const [facebook, setFacebook] = useState('');
  const [instagram, setInstagram] = useState('');
  const [linkedIn, setLinkedIn] = useState('');
  const [reddit, setReddit] = useState('');
  const [twitter, setTwitter] = useState('');

  const { errorToast } = useContext(ToastContext);

  useEffect(() => {
    const socials = company.socials || {};
    setDiscord(socials.discord?.url || '');
    setFacebook(socials.facebook?.url || '');
    setInstagram(socials.instagram?.url || '');
    setLinkedIn(socials.linkedIn?.url || '');
    setReddit(socials.reddit?.url || '');
    setTwitter(socials.twitter?.url || '');
    // eslint-disable-next-line
  }, []);

  const changeView = () => {
    window.scrollTo(0, 0);
    setShowUpdate(false);
  };

  const updateCompany = async () => {
    if (name === '' || bio === '') {
      errorToast('Name and Bio fields are required.');
      return;
    }

    const data = {
      id: company.id,
      name,
      bio,
      url,
      socials: {
        discord: { url: discord },
        facebook: { url: facebook },
        instagram: { url: instagram },
        linkedIn: { url: linkedIn },
        reddit: { url: reddit },
        twitter: { url: twitter }
      }
    };

    await client.updateCompany(data);
    await getCompany();
    setShowUpdate(false);
  };

  const renderSocialInput = (label, value, setValue, placeholder) => (
    <RowContainer margin={'10px 0'} flexDirection={setMobileView() ? 'column' : 'row'}>
      <Input
        type='text'
        name={label.toLowerCase()}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
      />
    </RowContainer>
  );

  return (
    <MainContainer>
      <Title>Update Company</Title>

      <Subtitle>Name</Subtitle>
      <RowContainer margin={'10px 0'}>
        <Input type='text' value={name} onChange={(e) => setName(e.target.value)} placeholder='Name' />
      </RowContainer>

      <Subtitle>Bio</Subtitle>
      <RowContainer margin={'10px 0'}>
        <Textarea value={bio} onChange={(e) => setBio(e.target.value)} placeholder='Bio' />
      </RowContainer>

      <Subtitle>Company URL</Subtitle>
      <RowContainer margin={'10px 0'}>
        <Input type='text' value={url} onChange={(e) => setUrl(e.target.value)} placeholder='URL' />
      </RowContainer>

      <Subtitle>Social Links</Subtitle>
      {renderSocialInput('Discord', discord, setDiscord, 'Discord')}
      {renderSocialInput('Facebook', facebook, setFacebook, 'Facebook')}
      {renderSocialInput('Instagram', instagram, setInstagram, 'Instagram')}
      {renderSocialInput('LinkedIn', linkedIn, setLinkedIn, 'LinkedIn')}
      {renderSocialInput('Reddit', reddit, setReddit, 'Reddit')}
      {renderSocialInput('Twitter', twitter, setTwitter, 'Twitter')}

      <RowContainer margin={'20px 0'}>
        <Button onClick={changeView}>Cancel</Button>
        <Button onClick={updateCompany}>Submit</Button>
      </RowContainer>
    </MainContainer>
  );
};

export default UpdateCompany;